'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MenuHeader;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SettingsArrow = require('../SettingsArrow');

var _SettingsArrow2 = _interopRequireDefault(_SettingsArrow);

var _style = require('./style.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
/**
 * Copyright 2013-2015, Hudl
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule MenuHeader
 */

function MenuHeader(_ref) {
  var label = _ref.label,
      onClick = _ref.onClick,
      children = _ref.children;

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { className: _style.menuHeader, onClick: onClick },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_SettingsArrow2.default, { type: 'left' }),
        _react2.default.createElement(
          'h3',
          null,
          label
        )
      )
    ),
    children
  );
}

MenuHeader.propTypes = {
  label: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func,
  children: _propTypes2.default.node
};

MenuHeader.displayName = 'MenuHeader';
module.exports = exports['default'];